import { Injectable } from '@angular/core';

import { StatsigService } from '@services/statsig.service';

export enum DEVICE_HUB_FEATURE_FLAGS {
  DEVICE_HUB_ENABLED = 'fe-dve-device-hub-enabled',
  AI_DASHCAM_PLUS_ONBOARDING = 'fe-dve-ai-dashcam-plus-onboarding-enabled',
  AI_DASHCAM_PLUS_ONBOARDING_PHASE_2 = 'fe-dve-ai-dashcam-plus-onboarding-phase-2-enabled',
  DVE_DISPLAY_CONNECTION_STATUS_FOR_VEHICLES = 'dve_display_connection_status_for_vehicles',
  DVE_LOW_VEHICLE_BATTERY = 'fe-dve-low-vehicle-battery-enabled',
}

@Injectable({ providedIn: 'root' })
export class DeviceHubFeatureFlagService {
  constructor(private statsigService: StatsigService) { }

  public isDeviceHubEnabled(): boolean {
    return this.statsigService
      .evaluateGate(DEVICE_HUB_FEATURE_FLAGS.DEVICE_HUB_ENABLED);
  }

  public isAIDashcamPlusOnboardingEnabled(): boolean {
    return this.statsigService
      .evaluateGate(DEVICE_HUB_FEATURE_FLAGS.AI_DASHCAM_PLUS_ONBOARDING);
  }

  public isAIDashcamPlusOnboardingPhase2Enabled(): boolean {
    return this.statsigService
      .evaluateGate(DEVICE_HUB_FEATURE_FLAGS.AI_DASHCAM_PLUS_ONBOARDING_PHASE_2);
  }

  public isDsiplayConnectionStatusForVehiclesEnabled(): boolean {
    return this.statsigService
      .evaluateGate(DEVICE_HUB_FEATURE_FLAGS.DVE_DISPLAY_CONNECTION_STATUS_FOR_VEHICLES);
  }

  public isLowVehicleBatteryEnabled(): boolean {
    return this.statsigService
      .evaluateGate(DEVICE_HUB_FEATURE_FLAGS.DVE_LOW_VEHICLE_BATTERY);
  }
}
